<template>
  <router-view/>
</template>

<style lang="scss">
@font-face {
    font-family: 'Alternate Gothic No3 D';
    src: url('~@/assets/fonts/AlternateGotNo3D.woff2') format('woff2'),
        url('~@/assets/fonts/AlternateGotNo3D.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}
@font-face {
    font-family: 'Custom Current Type';
    src: url('~@/assets/fonts/CustomCurrentType-Regular.woff2') format('woff2'),
        url('~@/assets/fonts/CustomCurrentType-Regular.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}


#app {
  font-family: 'Montserrat', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-weight: 400;
}
html, body {
  padding:0;
  margin:0;
  scroll-behavior: smooth;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background-color: var(--grey);
  }
  &::-webkit-scrollbar-thumb {
    background-color: var(--light-grey);
  }
}
:root {
  --light-grey:#656565;
  --grey:#242424;
  --dark-grey:#0F0F0F;
  --black:#010203;
  --white:#fff;
  --red:#FFA878;  
  --accent:#C88A65;
  --green:#00893E;
  --light-green:#F5FCE3;
  --ao-white:#F2F4F3;
  --ao-black:#011F44;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
